import request from '@/utils/request'
import { serviceUrl } from '../config/net.config'
export function queryService2(data) {
  return request({
    url: serviceUrl + '/api/supplier/queryService',
    head: 'application/json;charset=UTF-8',
    method: 'post',
    data: data,
    token:sessionStorage.getItem('xzztcToken')
  })
}
export function addSupplier(data) {
  return request({
    url: serviceUrl + '/api/supplier/addSupplier',
    method: 'post',
    head: 'application/json;charset=UTF-8',
    data,
    token:sessionStorage.getItem('xzztcToken')
  })
}

export function getSuppName(data) {
  console.log('data:', data)
  return request({
    url: serviceUrl + '/api/supplier/getSuppName',
    method: 'post',
    head: 'text/plain;charset=UTF-8',
    data,
    token:sessionStorage.getItem('xzztcToken')
  })
}

export function getUscCode(data) {
  return request({
    url: serviceUrl + '/api/supplier/getUscCode',
    method: 'post',
    head: 'text/plain;charset=UTF-8',
    data,
    token:sessionStorage.getItem('xzztcToken')
  })
}
export function deleteSuppliers(params) {
  return request({
    url: serviceUrl + '/api/supplier/deleteSuppliers',
    method: 'put',
    params: params,
    token:sessionStorage.getItem('xzztcToken')
  })
}

/**
 *  导入供应商库信息
 * @param data
 * @returns
 */
export function saveSupplier(data) {
  return request({
    url: serviceUrl + '/api/supplier/saveExcel',
    head: 'multipart/form-data',
    method: 'post',
    data: data,
    timeout: 1800000,
    token:sessionStorage.getItem('xzztcToken')
  })
}

/**
 *  导入供应商库信息excel到临时表
 * @param data
 * @returns
 */
export function saveSupplierTemp(data) {
  return request({
    url: serviceUrl + '/api/supplier/saveExcelTemp',
    head: 'multipart/form-data',
    method: 'post',
    data: data,
    token:sessionStorage.getItem('xzztcToken')
  })
}

/**
 *  查询供应商库信息临时表
 * @param data
 * @returns
 */
export function querySupplierTemp(data) {
  return request({
    url: serviceUrl + '/api/supplier/querySupplierFileTempForPC',
    head: 'application/json;charset=UTF-8',
    method: 'post',
    data: data,
    token:sessionStorage.getItem('xzztcToken')
  })
}

/**
 *  删除供应商库信息临时表数据
 * @param data
 * @returns
 */
export function deleteSupplierTemp() {
  return request({
    url: serviceUrl + '/api/supplier/deleteSupplierFile',
    head: 'application/json;charset=UTF-8',
    method: 'delete',
    token:sessionStorage.getItem('xzztcToken')
  })
}
/**
 *  导出供应商库信息表数据
 * @param data
 * @returns
 */
export function exportSupplierData() {
  return request({
    url: serviceUrl + '/api/supplier/exportSupplierData',
    method: 'post',
    responseType: 'blob',
    token:sessionStorage.getItem('xzztcToken')
  })
}
// 首页查询个供应商合同总数接口
export function getContractsInSupplier() {
  return request({
    url: serviceUrl + '/api/supplier/getContractsInSupplier',
    method: 'get',
    token:sessionStorage.getItem('xzztcToken')
  })
}
export function getAuthCode(data) {
  return request({
    url: serviceUrl + '/api/supplier/getAuthCode?mobile='+data,
    method: 'get',
    token:sessionStorage.getItem('xzztcToken')
  })
}
export function checkAuthCode(data1,data2) {
  return request({
    url: serviceUrl + '/api/supplier/checkAuthCode?key='+data1+"&authCode="+data2,
    method: 'get',
    token:sessionStorage.getItem('xzztcToken')
  })
}
/**
 * 根据字典取数据
 * @param {*} params 
 * @returns 
 */
export function getSysDict(params) {
  return request({
    url: '/base/getSysDict?dictTypeCode=' + params,
    method: 'get',
  })
}
